import { render, staticRenderFns } from "./AvatarsView.vue?vue&type=template&id=748f0611"
import script from "./AvatarsView.vue?vue&type=script&lang=js"
export * from "./AvatarsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports